var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 158,
    viewBox: "0 0 59 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4072 8.64658L29.7483 0.421678L21.5234 29.0806L32.673 22.9036C35.9485 28.1227 38.7485 33.6534 40.9872 39.4709C43.2158 45.2701 44.8913 51.3276 45.9426 57.515C48.0552 69.9081 47.7095 82.8469 44.8372 95.385C41.9833 107.913 36.6008 119.993 28.9886 130.692C25.1825 136.042 20.8343 141.019 16.0074 145.566C11.1804 150.113 5.87259 154.181 0.186059 157.74C6.20841 154.788 11.9622 151.264 17.3536 147.173C22.7451 143.082 27.7557 138.433 32.2856 133.307C41.3454 123.054 48.4168 110.902 52.9154 97.7034C57.4242 84.5227 59.3888 70.3029 58.4592 56.102C58.0087 49.0057 56.8443 41.9208 54.9903 34.9779C53.1364 28.0349 50.5847 21.2625 47.3963 14.7707L58.4173 8.66494L58.4072 8.64658Z",
    fill: "#83DEFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4072 8.64658L29.7483 0.421678L21.5234 29.0806L32.673 22.9036C35.9485 28.1227 38.7485 33.6534 40.9872 39.4709C43.2158 45.2701 44.8913 51.3276 45.9426 57.515C48.0552 69.9081 47.7095 82.8469 44.8372 95.385C41.9833 107.913 36.6008 119.993 28.9886 130.692C25.1825 136.042 20.8343 141.019 16.0074 145.566C11.1804 150.113 5.87259 154.181 0.186059 157.74C6.20841 154.788 11.9622 151.264 17.3536 147.173C22.7451 143.082 27.7557 138.433 32.2856 133.307C41.3454 123.054 48.4168 110.902 52.9154 97.7034C57.4242 84.5227 59.3888 70.3029 58.4592 56.102C58.0087 49.0057 56.8443 41.9208 54.9903 34.9779C53.1364 28.0349 50.5847 21.2625 47.3963 14.7707L58.4173 8.66494L58.4072 8.64658Z",
    fill: "url(#paint0_linear_11393_2034)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11393_2034",
    x1: -44.8497,
    y1: 44.5158,
    x2: 96.7846,
    y2: 66.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowUp);
export default __webpack_public_path__ + "static/media/long-arrow-up.b0e4e4bd160c69a88ed073193ae85472.svg";
export { ForwardRef as ReactComponent };